// extracted by mini-css-extract-plugin
export var container = "_4y-0";
export var icon = "_4y-1";
export var text = "_4y-2";